import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { Page } from '../components';
import { reactPlugin } from "../AppInsights";
import { QRCodeScanner } from '../features/QRCodeScanner'
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

const QrScan = () => {
    const intl = useIntl();
    const nav = useNavigate();

    const handleQrResult = (decodedText: string, result: any) => {
        nav(`/Objects/${decodedText}`);
    }
    return (
        <Page header={intl.formatMessage({ id: "Pages.QRCode.header", defaultMessage: "QRCode" })} subheader={intl.formatMessage({ id: "Pages.QRCode.subheader", defaultMessage: "Scan your QRCode" })}>
            <QRCodeScanner onResult={handleQrResult}></QRCodeScanner>
        </Page>
    )
}


export default withAITracking(reactPlugin, QrScan);